import axios from 'axios'
import { getBaseApiUrl } from 'services/api.service'
import DeclarationApi from '../apiConfig'
import {
  DocumentRequest, DocumentRequestTypeEnum, DocumentResponse, FileResponse,
} from '../../../../../api/models'

const {
  baseUrl,
} = DeclarationApi.paths.document

export async function postDocument(data: DocumentRequest[]) {
  return (await axios.post<DocumentResponse[]>(baseUrl, data)).data
}

export async function putDocument(data: DocumentRequest[]) {
  return (await axios.put<DocumentResponse[]>(`${baseUrl}`, data)).data
}

export async function postFiles(data: FormData) {
  return (await axios.post<FileResponse>(getBaseApiUrl('/v2/document-file'), data)).data
}

export async function getDocuments(transitOperationId: number | null, documentType: DocumentRequestTypeEnum) {
  return (await axios.get<DocumentResponse[]>(
    `${baseUrl}/${transitOperationId}`,
    {
      params: { documentType },
    },
  )).data
}

export async function deleteFile(props: { folder: string; uuid: string }) {
  return (await axios.delete<void>(`${getBaseApiUrl(`/v2/document-file/${props.folder}/${props.uuid}`)}`)).data
}
